import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface StubPageProps {
  title: string;
}

export default function StubPage({ title }: StubPageProps) {
  return (
    <div className="flex items-center justify-center py-20">
      <Card className="max-w-md text-center">
        <CardHeader>
          <CardTitle>{title}</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">
            Coming in a future session
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
